export const events = (time, title) =>
  `<div class="event__time">${time}</div>
        <div class="event__title">${title}</div>`;
